export default {
  studentScore: {
    id: "",
    studentEnrollDetail: null,
    subject: null,
    subjectCode: null,
    student: null,
    studentCode: null,
    teacher: null,
    teacherCode: null,
    classSection: null,
    sectionNo: null,
    fullScore: null,
    totalScore: null,
    studentScoreDetails: []
  },

  studentScores: [],
  processing: false,
  error: null,
  success: null,
}



